module.exports = __webpack_public_path__ + "assets/e5fec2bde8b4acc77c119149c68f229c.png";